import _extends from "@babel/runtime/helpers/extends";
import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const SIZE_STANDARD = "standard";
export const SIZE_NARROW = "narrow";
export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";
export const THEME_GRAY = "gray";
export const THEME_TRANSPARENT = "transparent";
export const Button = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.as]
 * @param {any} props.children
 * @param {string} [props.type]
 * @param {((props: { disabled: boolean, theme: string, size: string }) => object) | string | { [key: string]: any }} [props.className]
 * @param {boolean} [props.disabled]
 * @param {SIZE_STANDARD|SIZE_NARROW} [props.size]
 * @param {THEME_LIGHT|THEME_DARK|THEME_GRAY|THEME_TRANSPARENT|"none"} [props.theme]
 * @param {string} [props.title]
 * @param {(e: MouseEvent) => ({} | void)} [props.onClick]
 * @param {(e: MouseEvent) => ({} | void)} [props.onHover]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Button({
  as = "button",
  children,
  className,
  disabled = false,
  size = SIZE_STANDARD,
  theme = THEME_LIGHT,
  title,
  onClick = e => ({
    e
  }),
  onHover = e => ({
    e
  }),
  ...props
}, ref) {
  const EL = as;
  const buttonClassName = classnames(classnames(["font-bold px-4 rounded focus:outline-none hover:shadow-md"], {
    "text-md py-3": size === SIZE_STANDARD,
    "py-1": size === SIZE_NARROW,
    "text-black bg-en-yellow-700": !disabled && theme === THEME_LIGHT,
    "text-white bg-en-gray-700": !disabled && theme === THEME_DARK,
    "text-en-gray-900 bg-en-gray-200": !disabled && theme === THEME_GRAY,
    "text-en-gray-900 bg-transparent": !disabled && theme === THEME_TRANSPARENT,
    "text-gray-800 bg-en-gray-100 border-en-gray-100 cursor-not-allowed": disabled
  }), typeof className === "function" ? className({
    disabled,
    theme,
    size
  }) : className);
  const onClickHandler = e => {
    e?.stopPropagation();
    onClick(e);
  };
  return /*#__PURE__*/React.createElement(EL, _extends({}, props, {
    className: buttonClassName,
    title: title,
    "aria-label": title,
    onClick: onClickHandler,
    onMouseOver: onHover,
    disabled: disabled,
    ref: ref
  }), children);
});
Button.propTypes = {
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType]),
  children: PropTypes.any.isRequired,
  className: PropTypes.any,
  disabled: PropTypes.bool,
  size: PropTypes.any,
  theme: PropTypes.any,
  title: PropTypes.string,
  onClick: PropTypes.func,
  onHover: PropTypes.func
};